import { CreditReportProductDetail } from "Views/Components/CreditReportSettings/CreditReportProductList"
import { SelectedProductSegment } from "../Gibs/SelectedProductSegment"
import { PaymentSummarySegment } from "../Gibs/PaymentSummarySegment"
import InlineSpinner from "Views/Components/Spinner/InlineSpinner"
import { MonitorCustomerDetail } from "../../GenerateCreditReport"
import useAsync from "Hooks/useAsync"
import axios from "axios"
import { SERVER_URL } from "Constants"
import { CustomerEntity } from "Models/Entities"
import { accountType } from "Models/Enums"
import React from "react"
import { AddNewCustomerSegment } from "../Gibs/MonitorCustomerSegment"
import { store } from "Models/Store"
import useGqlBusiness from "Hooks/Api/useGqlBusiness"
import { AustralianEntitySearchBoxSegment } from "../../../JurisdictionBusinessEntitySearchBox/AustralianEntitySearchBoxSegment"

type Props = {
	creditReportSubject: {
		name: string,
		status: string,
		address: string,
		lookupValue: string,
		lookupMethod: "ABN" | "ACN" | "NCN",
	},
	billingEntityName: string,
	orgAccountType: accountType,
	orgId: string,
	businessEntityId: string,
	selectedProducts: CreditReportProductDetail[],
	removeProduct: (product: CreditReportProductDetail) => void,
	monitorCustomer: MonitorCustomerDetail | null,
	handleMonitorCustomer: (detail: MonitorCustomerDetail | null) => void,
	moveBack: () => void,
}

export const ReviewReportSection:React.FunctionComponent<Props> = ({
	creditReportSubject,
	billingEntityName,
	orgAccountType,
	orgId,
	businessEntityId,
	selectedProducts,
	removeProduct,
	monitorCustomer,
	handleMonitorCustomer,
	moveBack,
}) => {
	const isLookupMethodAbn = creditReportSubject.lookupMethod === "ABN";
	const availableCustomerResponse = useAsync(async () => {
		if (isLookupMethodAbn) {
			const lookupMethod = creditReportSubject.lookupMethod;
			const lookupValue = creditReportSubject.lookupValue;
			const url = `${SERVER_URL}/api/entity/CustomerEntity/`;
			const res = await axios.get<{data: CustomerEntity[],count: number}>(url, {
				params: {
					SearchType: lookupMethod,
					SearchTerm: lookupValue,
					OrganisationId: orgId,
					BusinessEntityId: businessEntityId,
				}
			});

			return res.data;
		}

		return {data: [] as CustomerEntity[], count: 0};
	}, [isLookupMethodAbn]);

	const businessEntityDetail =  useGqlBusiness({ filterByOrgId: orgId, filterByMonitor: true });

	if (availableCustomerResponse.type === 'loading' || businessEntityDetail.type === 'loading') {
		return <InlineSpinner />
	}

	const selectedBusinessEntity = businessEntityDetail.data?.find(entity => entity.id === businessEntityId);
	const isAddNewCustomerReadOnly = availableCustomerResponse.data?.count !== 0;
	const hasPermission = store.canAccessIntel && selectedBusinessEntity?.enabledForMonitor;

	return (
		<>
			<AustralianEntitySearchBoxSegment
				title="Credit report subject"
				entityName={creditReportSubject.name}
				entityStatus={creditReportSubject.status}
				entityAddress={creditReportSubject.address}
				lookupValue={creditReportSubject.lookupValue}
			/>
			<SelectedProductSegment
				creditReportProducts={selectedProducts}
				removeProduct={removeProduct}
				moveBack={moveBack}
			/>
			{/*
				- display only if no customer match found
				- only for ABN
				- only if the customer is not already a customer
				- future: let user decide the customer if multiple customers found
			*/}
			{isLookupMethodAbn &&  (
				<AddNewCustomerSegment
					orgAccountType={orgAccountType}
					lookupValue={creditReportSubject.lookupValue}
					businessName={creditReportSubject.name}
					monitorCustomer={monitorCustomer}
					isReadOnly={!hasPermission }
					isExistingCustomer={isAddNewCustomerReadOnly}
					updateMonitorCustomer={handleMonitorCustomer}
				/>
			)}
			{selectedProducts.length > 0 && (
				<PaymentSummarySegment
					businessEntityName={billingEntityName}
					creditReportProducts={selectedProducts}
					monitorCustomer={monitorCustomer}
				/>
			)}
		</>
	)
}